import type { CommissionOption } from '~/consts/agentHub';

import type { CruiseLine } from '~/services/cruises/CruiseLineService';

export type CruiseLineOption = {
  value: string;
  label: string;
  code?: string;
};

type CruiseLineIdentity = Pick<CruiseLine, 'code' | 'name'>;

export function cruiseLineToOption(cruiseLine: CruiseLineIdentity): CruiseLineOption {
  return {
    value: cruiseLine.code,
    label: cruiseLine.name,
    code: cruiseLine.code,
  };
}

export function resolveCruiseLineOptions(
  conditions: CommissionOption,
  cruiseLines: Array<CruiseLineIdentity>,
): Array<CruiseLineOption> {
  return conditions.map((condition) => {
    const value = String(condition.value);
    // Match codes first so an existing code cannot be mistaken for another line's name.
    const cruiseLine =
      cruiseLines.find((line) => line.code === value) ?? cruiseLines.find((line) => line.name === value);

    return cruiseLine ? cruiseLineToOption(cruiseLine) : { value, label: String(condition.label || condition.value) };
  });
}

export function cruiseLineOptionToCondition(option: CruiseLineOption): CommissionOption[number] {
  return { value: option.value, label: option.label };
}
